export default __webpack_public_path__ + "static/media/Juan Rossi.97012965.jpg";